import { useContext } from 'react';

import AssigneeFilter from '@atom/components/common/assigneeFilter/AssigneeFilter';
import WorkOrdersContext, {
  WorkOrdersInputActionTypes,
} from '@atom/components/workOrders/WorkOrdersContext';

const WorkOrdersAssigneeFilter = () => {
  const { workOrdersInputCart, filtersDisabled, dispatch } =
    useContext(WorkOrdersContext);

  const onChange = (userIds: string[], groupIds: string[]) => {
    dispatch({
      type: WorkOrdersInputActionTypes.UPDATE_WORK_ORDERS_INPUT_PROPERTY,
      data: {
        property: 'userIds',
        value: userIds,
      },
    });

    dispatch({
      type: WorkOrdersInputActionTypes.UPDATE_WORK_ORDERS_INPUT_PROPERTY,
      data: {
        property: 'groupIds',
        value: groupIds,
      },
    });
  };

  return (
    <AssigneeFilter
      userIds={workOrdersInputCart.userIds || []}
      groupIds={workOrdersInputCart.groupIds || []}
      onChange={onChange}
      disabled={filtersDisabled}
      includeQuickOptions
      dataCy="workOrdersFilterAssignedToInput"
    />
  );
};

export default WorkOrdersAssigneeFilter;
